require('../scss/information.scss');
// require('bootstrap-sass/assets/stylesheets/_bootstrap.scss');
// require('bootstrap-sass/assets/stylesheets/_bootstrap.scss');
require('../scss/utils/bootstrap/bootstrap.min.css');

require('animate.css/animate.min.css');
var $ = require('jquery');
var common = require('./common');

var lang='';
//var icon = require('../img/favicon.jpg');
//console.log(icon);
//alert('hello world');

$( document ).ready(function() {

    lang = common.initChangePage();
    if(lang == 'en'){
        $('.zh').addClass('f-fHNLTP63ME');
    }else{
        $('.en').addClass('f-fZHBold');
    }
    $(`.showHidden`).click(function(){
        if($(`.showHidden`).hasClass('active')){
            $(`.showHidden`).removeClass('active')
            $(`.showHidden ul`).slideUp()
        }else{
            $(`.showHidden`).addClass('active')
            $(`.showHidden ul`).slideDown()
        }

    })
    $(".showHidden a").click(function(event) {
        event.stopPropagation();
    });






});







// WEBPACK FOOTER //
// ./src/information.js